import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { Button, Card, ColorPicker, Container, Input, InputWrapper, Main, PageHeader, Stepper } from '../../Components'
import debounce from 'lodash.debounce';
import { useMemo } from 'react'
import { useNavigate , Link, useSearchParams  } from 'react-router-dom'
import axios from 'axios'
import { ReactComponent as Browserbar } from '../../assets/images/google-chrome-browser-light.svg'
import toast from 'react-hot-toast';
import Tooltip from 'rc-tooltip';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { login, updateOrganizationPages, updateUserOrganizationPageByID } from '../../Redux/features/authSlice';
import {StatusPageContentDemo} from './../Statuspages/StatusPageContentDemo'
import { ReactComponent as Logo } from './../../assets/logo/logo.svg'
import './Create.css'
import { updateGeneralUI } from '../../Redux/features/uiReducer';
import { ReactComponent as LoadingIcon } from './../../assets/icons/loading.svg'
import { useEffect } from 'react';

export function InitCreatePage() {


	const regex_validator = {
		subdomain : /^[A-Za-z0-9\-\_]+$/,
		email : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		colorHex : /^\#[0-9a-zA-Z]{6,20}$/,

	}

    const [searchParams] = useSearchParams();

	const navigate = useNavigate();
	const { user , org } = useSelector((state) => state.auth)
	const dispatch = useDispatch()

	const [activeStep, setActiveStep] = useState(0);
	const [formData, setFormData] = useState({
		email: "",
		name: "",
		subdomain: "",
		components: [ "Homepage", "Api" ],
		background_color: "#0013ce",
		header_text_color: "#ffffff",
		logo: "",
		favicon: "",
		 
	});
	const [formValidation, setFormValidation] = useState({
		email : "",
		name : "",
		subdomain : "",
		background_color : '',
		header_text_color : ''

	})
	const [isCheckingSubdomain, setIsCheckingSubdomain] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [pageIsLoading, setPageIsLoading] = useState(false)
	const [sessionToken, setSessionToken] = useState(null)

    useEffect(() => {
        const _subdomain = searchParams.get('subdomain')
        if(typeof _subdomain !=='undefined' && _subdomain !==''){
            setFormData( prevState => ({
                ...prevState,
                subdomain : _subdomain
            }))
        }
    }, [])
    



	const nextStep = async () => {
	   
		setPageIsLoading(true)
		// Validate the form fields 
			// Step 1 : 
			switch (activeStep) {
				// ? 1st step >> Check the name + subdomain 
				case 0: 
					const validationName = (formData.name === '') ? 'Required Field' : ''
					// Check the email 
					let validationEmail = (formData?.email === '') ? 'Required Field' : ''// (formData.subdomain.match(regex_validator.subdomain)===null) ? 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"' : ''
					// ! Check the syntaxe 
					if(formData.email.match(regex_validator.email)===null){
						validationEmail = 'Invalid email'  
						
					}

					// Check the subdomain 
					let validationSubdomain = (formData?.subdomain === '') ? 'Required Field' : ''// (formData.subdomain.match(regex_validator.subdomain)===null) ? 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"' : ''
					// ! Check the syntaxe 
					if(formData.subdomain.match(regex_validator.subdomain)===null){
						validationSubdomain = 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"'  
						
					}else{
						validationSubdomain = 'The selected subdomain is not available!'
						// ! Check the availability 
						try {
							const response = await checkSubdomainAvailability(formData.subdomain)
							

							
							if(response && response?.availability === true ) validationSubdomain = '';
							

						} catch (error) {}

						
					}
					
					setFormValidation((prevState) => ({
						...prevState,
						name: validationName,
						email: validationEmail,
						subdomain: validationSubdomain
					}))


					if(validationName ==='' && validationSubdomain ==='' && validationEmail === ''){
						// Pass to next step 
						setActiveStep((current) => (current < 2 ? current + 1 : current));
					}else{
						toast.error("Please complete all required")
					}


					break;
				// ? 2nd step >> Check the components items 
				case 1:

					const validComponents = formData.components.filter( x=> x !=='');
					if(validComponents.length > 0){
						// Pass to next step 
						setActiveStep((current) => (current < 2 ? current + 1 : current));
						
					}else{
						toast.error("Please add at least one component")
						 
					}

					 
					break;
				// ? Form submit : save the new status page 
				case 2:

					try {
						
						const response = await savePage();
						toast.success('Your status page has been successfully created')
						navigate(`/pages/${response?.page?.id}`)	
						// setTimeout(() => {
						// }, 2000);

					} catch (error) {
						 
						toast.error(error?.response?.data?.message ?? 'Something went wrong, please try again later.')
					}
				break;
				default : break;
			}

			setPageIsLoading(false)
 
	}
	const prevStep = () => setActiveStep((current) => (current > 0 ? current - 1 : current));

	const onChange = async ({ target: { name, value } }) => {

		switch(name){
			case "name" : 
				setFormValidation((prevState) => ({
					...prevState,
					name: (value === '') ? 'Required Field' : ''
				}))
				
				break;
			case "email" : 

				let validationEmail = (value ==='') ? 'Required Field' : ''// (formData.subdomain.match(regex_validator.subdomain)===null) ? 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"' : ''
				// ! Check the syntaxe 
				if(value.match(regex_validator.email)===null){
					validationEmail = 'Invalid email'  
					
				}
				setFormValidation((prevState) => ({
					...prevState,
					email: validationEmail
				}))
				
				break;
			 
			 
		}

		setFormData( (prevState) => {
			if(['name' , 'email', 'logo', 'favicon' ].includes(name)){
				return {
					...prevState,
					[name] : value
				}
			}

			// to get 0/1/2 from component-0/component-1/component-2
			const componentIndex = +name[name.length - 1];

			return {
				...prevState,
				components: Object.assign([...prevState.components], { [componentIndex]: value })
			};


		})
	};

	/**
	 * CHECK THE AVAILABILITY OF THE SUBDOMAIN + REGEX
	 */
	const changeSubdomain = async ({ target : { name , value}}) => {

		 
		setIsCheckingSubdomain(true)

		let validationMessage = '';

		value = value.toLowerCase();

		setFormData( (prevState) => ({
			...prevState,
			subdomain : value
		}))

	 
		// ! Check the syntaxe 
		if(value.match(regex_validator.subdomain)===null){
			validationMessage = 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"'  
			 
		}else{
			validationMessage = 'The selected subdomain is not available!'
			 
			// ! Check the availability 
			 
			try {
				const response = await checkSubdomainAvailability(value)
				
				 

				
				if(response && response?.availability === true ) validationMessage = '';
				 

			} catch (error) {

				 
			}

			 
		}

		

		 

		setFormValidation((prevState) => ({
			...prevState,
			subdomain :  validationMessage
		}))

		setIsCheckingSubdomain(false)

	}


	/**
	 * 
	 * @param {*} subdomain 
	 */
	const checkSubdomainAvailability = async (subdomain) => {
		
		return new Promise(async (resolve, reject) => { 

				await axios
				.post(`${process.env.REACT_APP_API_URL}/statuspages/availability/subdomain`, {
					hosted_subdomain : subdomain
				} , {
					headers : {
						'Content-Type': 'application/json',
						// 'Authorization': `Bearer ${token}`,//'JWT token...'
						
					}
				} )
				.then(res => res.data )
				.then(async response => {

					resolve(response)
					
				})
				.catch(error => {

					reject(error) 
				})
			 
		})


	}


	const onChangeSubdomain = useMemo(
		() => debounce(changeSubdomain, 300)
	  , []);
	

	const addComponent = () => {
		setFormData(prevState => ({
			...prevState,
			components : [ ...prevState.components , ""]	
		}))
	}

	const removeComponent = (componentIndex) => {
 	 

		const components = [...formData.components];
		components.splice(componentIndex, 1)
		setFormData( prevState => ({
			...prevState,
			components : components
		}))

		 
	}

	/**
	 * 
	 * @returns 
	 */
	const savePage = () => {

		return new Promise(async (resolve, reject) => { 

			 
	
				await axios
				.post(`${process.env.REACT_APP_API_URL}/statuspages/create`, {
					email : formData.email,
					name : formData.name,
					hosted_subdomain : formData.subdomain,
					components : formData.components.filter( x=> x!==""),


					background_color : formData?.background_color ?? '#0013ce',
					header_text_color : formData?.header_text_color ?? '#ffffff' ,
					favicon : formData?.favicon ,
					logo : formData?.logo ,
				} , {
					headers : {
						'Content-Type': 'application/json',
						// 'Authorization': `Bearer ${token}`,//'JWT token...'
						
					}
				} )
				.then(res => res.data )
				.then(async response => {

					if (typeof response?.user?.token !== 'undefined' && response?.user?.token !== null) {

					
						localStorage.setItem(process.env.REACT_APP_STORAGE_AUTH_USER, JSON.stringify(response?.user))
						localStorage.setItem(process.env.REACT_APP_STORAGE_AUTH_ORG, JSON.stringify(response?.user?.organizations?.find(x => x.is_default === true) ?? (response?.user?.organizations?.length > 0 ?response?.user?.organizations[0] : {})))
						 
						dispatch(login(response?.user));
						dispatch(updateGeneralUI({
							show_sidebar : true
						}))
						 
						setSessionToken(response?.user?.token)
						
						setIsLoading(false)
						
					}
					addPageToRedux(response?.page)
					resolve(response)
					
				})
				.catch(error => {

					reject(error) 
				})
			 
		})

	}


	const addPageToRedux = (pageData) => {
		let statuspages = [...org?.statuspages??[] , {
			id : pageData?.id,
			name : pageData?.name,
			organization_legal_name : pageData?.organization_legal_name,
			website_url : pageData?.website_url,
			support_url : pageData?.support_url,
			created_at : pageData?.created_at,
			type : pageData?.type,
			custom_domain : pageData?.custom_domain,
			hosted_subdomain : pageData?.hosted_subdomain,
			logo : pageData?.logo,
			favicon : pageData?.favicon,
			is_active : pageData?.is_active,
			status : pageData?.status,
		}];
		 

		dispatch(updateOrganizationPages(statuspages))

		// ! Add a new status page to : REDUX > USER > ORGANIZATIONS [ INEDX ] > STATUSPAGES 
		dispatch(updateUserOrganizationPageByID({
			organization_id : org?.id ,
			action : 'new',
			data : {
				id : pageData?.id,
				name : pageData?.name,
				organization_legal_name : pageData?.organization_legal_name,
				website_url : pageData?.website_url,
				support_url : pageData?.support_url,
				created_at : pageData?.created_at,
				type : pageData?.type,
				custom_domain : pageData?.custom_domain,
				hosted_subdomain : pageData?.hosted_subdomain,
				logo : pageData?.logo,
				favicon : pageData?.favicon,
				is_active : pageData?.is_active,
				status : pageData?.status,
			}
		}))
	}


	return (
		<>
		<Helmet>
			<title>{`Create status page - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			withNav={false}
			mutedBackground={true}
			className='create-new-page'
			 >
			<div className="formHeader">
				<div className="logo">
					<Logo />
				</div>
				<PageHeader
					title={`Create a status page`}
					// description="Give your account a recognisable name, so your team mates can easily switch between accounts."
					/>

			</div>
			<div className="create-statuspage-form">
				{
					pageIsLoading && <>
						<div className="cover-loading"></div>
						<div className='page-loading' title="Loading..."><LoadingIcon /></div>
					</>
				}
				<form action="">
					<div className="step-header">
						<Stepper 
							activeStep={activeStep}
							// onStepClick={setActiveStep}
							steps={[
								{
									label : "Name/Subdomain",
									description :"Basic information" 
								},
								{
									label : "Components",
									description :"Add components" 
								},
								{
									label : "Design",
									description :"Customize theme" 
								}
							]}

							/>

					</div>
					<div className="step-content">
						{
							activeStep === 0 && 
							<>
							<div className="content-grid">
								<div className="grid-column">
									<Input
										name='email'
										placeholder=""
										label="Email"
										required
										mb={15}
										onChange={onChange}
										error={formValidation.email}
										value={formData.email}
										inputclassname={'bg-white'}
										/>
									<Input
										name='name'
										placeholder=""
										label="Company name"
										required
										mb={15}
										onChange={onChange}
										error={formValidation.name}
										value={formData.name}
										inputclassname={'bg-white'}
										/>
									<Input
										//icon={isCheckingSubdomain === true && <Loader size="xs" style={{ left : '-40px'}} />}
										name='subdomain'
										placeholder=""
										label="Subdomain"
										prefix={<div >https://</div>}
										suffix={<div >{process.env.REACT_APP_STATUSPAGE_HOSTNAME}</div>}
										
										required
										mb={15}
										onChange={onChangeSubdomain}
										defaultValue={formData.subdomain}
										error={isCheckingSubdomain === true ? 'Checking...' : formValidation.subdomain}
										inputclassname={'bg-white'}
										/>
								</div>
								<div className="grid-column">
									<div className='preview-step-processing'>
										<div className="browserbar-wrapper">
											<Browserbar  />
											<div className="statuspage-name">{formData?.name}</div>
											<div className="statuspage-url">
												<div className="preview-prefix">https://</div>
												<div className={`preview-subdomain ${formValidation?.subdomain === '' ? 'success' : 'danger'}`}>{formData?.custom_domain ?? formData?.subdomain}</div>
												<div className="preview-suffix">{process.env.REACT_APP_STATUSPAGE_HOSTNAME}</div>
											</div>
										</div>
										<StatusPageContentDemo 
											name={formData?.name}
											url={`https://${formData?.subdomain}${process.env.REACT_APP_STATUSPAGE_HOSTNAME}`}
											components={formData?.components.map( (cp , i ) => ({
												name : cp ,
												id : i,
												display_chart : true ,
												status : 'OPERATIONAL'
												

											}) )}
										/>
									</div>
								</div>
							</div>
							</>
						}
						{
							activeStep === 1 && 
							<>
							<div className="content-grid">
								<div className="grid-column">
									<InputWrapper
										label="Add components"
										description="In your application or service, components are what make it work and may be unavailable at times.">
										{
											formData?.components?.map( (obj , index) => {
												
												return (
													<div key={index} className="component-row mb-5">
														<div  className="c-row-input" >
															<Input
																value={obj}
																name={`component-${index}`}
																placeholder={`Put your component here`}
																onChange={onChange}
																inputclassname={'bg-white'}
															/>
														</div>
														<div className="c-row-btns">
															{
																index > 0 && 
																<Tooltip 
																	placement="top" 
																	trigger={['hover']} 
																	overlay="Remove this component" 
																	>
																	<Button 
																		color="gray"
																		onClick={() => removeComponent(index)}
																		name={`mins-component-${index}`}
																		>
																			<AiOutlineMinus />
																		</Button>
																</Tooltip>
															}
															{
																formData?.components?.length-1 === index && 
																<Tooltip 
																	placement="top" 
																	trigger={['hover']} 
																	overlay="Add new component" 
																	  >
																	<Button 
																		p={10}
																		color="purple"
																		onClick={addComponent}
																		>
																			<AiOutlinePlus />
																		</Button>
																</Tooltip>
															}
														</div>
													</div>

												)
											})
										}	
									</InputWrapper>
								</div>
								<div className="grid-column">
									<div className='preview-step-processing'>
										<div className="browserbar-wrapper">
										<Browserbar  />
											<div className="statuspage-favicon"><img src={formData?.favicon} /></div>
											<div className="statuspage-name">{formData?.name}</div>
											<div className="statuspage-url">
												<div className="preview-prefix">https://</div>
												<div className={`preview-subdomain ${formValidation?.subdomain === '' ? 'success' : 'danger'}`}>{formData?.custom_domain ?? formData?.subdomain}</div>
												<div className="preview-suffix">{process.env.REACT_APP_STATUSPAGE_HOSTNAME}</div>
											</div>
										</div>
										<StatusPageContentDemo 
											name={formData?.name}
											url={`https://${formData?.subdomain}${process.env.REACT_APP_STATUSPAGE_HOSTNAME}`}
											components={formData?.components.map( (cp , i ) => ({
												name : cp ,
												id : i,
												display_chart : true ,
												status : 'OPERATIONAL'

											}) )}
										/>
									</div>
								</div>
							</div>
							</>
						}
						{
							activeStep === 2 && 
							<>
							<div className="content-grid">
								<div className="grid-column">
									<Input
										label="Logo"
										placeholder="URL to company logo"
										name="logo"
										onChange={onChange}
										value={formData?.logo}
										error={formValidation?.logo}
										inputclassname={'bg-white'}
										/>
									<Input
										label="Favicon"
										placeholder="URL to company favicon"
										name="favicon"
										onChange={onChange}
										value={formData?.favicon}
										error={formValidation?.favicon}
										inputclassname={'bg-white'}
										/>
									<InputWrapper 
										label={`Background Color`}
										error={formValidation?.background_color} >
										<ColorPicker 
											defaultColor={formData?.background_color}
											onComplete={ ( color ) => {
												setFormData((prevState) => ({
													...prevState,
													background_color : color
												}))
											}} />
										
									</InputWrapper>
									<InputWrapper 
										label={`Header Text Color`}
										error={formValidation?.header_text_color} >
										<ColorPicker 
											defaultColor={formData?.header_text_color}
											onComplete={ ( color ) => {
												setFormData((prevState) => ({
													...prevState,
													header_text_color : color
												}))
											}} />
										
									</InputWrapper>
									
								</div>
								<div className="grid-column">
									<div className='preview-step-processing'>
										<div className="browserbar-wrapper">
										<Browserbar  />
											<div className="statuspage-favicon"><img src={formData?.favicon} /></div>
											<div className="statuspage-name">{formData?.name}</div>
											<div className="statuspage-url">
												<div className="preview-prefix">https://</div>
												<div className={`preview-subdomain  success`}>{formData?.custom_domain ?? formData?.subdomain}</div>
												<div className="preview-suffix">{process.env.REACT_APP_STATUSPAGE_HOSTNAME}</div>
											</div>
										</div>
										<StatusPageContentDemo 
											name={formData?.name}
											url={`https://${formData?.subdomain}${process.env.REACT_APP_STATUSPAGE_HOSTNAME}`}
											logo={formData?.logo}
											background_color={formData?.background_color}
											header_text_color={formData?.header_text_color}
											components={formData?.components.map( (cp , i ) => ({
												name : cp ,
												id : i,
												display_chart : true ,
												status : 'OPERATIONAL'

											}) )}
										/>
									</div>
								</div>
							</div>    
							</>
						}
					</div>	
					<div className='step-footer'>
						<Container className="flex-end gap-10">
							{
								activeStep === 0 
								? <Link to="/pages"><Button color="gray">Back</Button></Link>
								: <Button color="gray" variant="default" onClick={prevStep}>Back</Button>
							}
							
							<Button onClick={nextStep}>{activeStep < 2 ? 'Next' : 'Save & activate your status page'}</Button>
						</Container>
					</div>
				</form>
			</div>
		</Main>
		</>
	)
} 